// extracted by mini-css-extract-plugin
export default {"tab":"handle-user-modal_tab__9J9m7","hidden":"handle-user-modal_hidden__LvC-z"};